import {Pipe, PipeTransform} from '@angular/core';
import {Team} from "@team/model";

@Pipe({
  name: 'teamInArray'
})
export class TeamInArrayPipe implements PipeTransform {
  transform(value: Team, teams: Team[]): boolean {
    if(teams.length === 0) {
      return true;
    }

    return teams.some(x => value.id === x.id);
  }
}
